export default __webpack_public_path__ + "static/media/Copy of 10-Get-Regular-Checkups.94cbb5b3.jpg";